import { AxiosResponse } from "axios";
import { FreeTrialUsageReportFiltersDto, FreeTrialUsageReportResponse } from "@/models/FreeTrialUsageReport";
import Repository from "./Repository";

const resource = "/FreeTrialUsageReport";

export default {
  getReport(payload: FreeTrialUsageReportFiltersDto): Promise<AxiosResponse<FreeTrialUsageReportResponse>> {
    return Repository.post(`${resource}/GetReport`, payload, { withCredentials: true });
  },
  exportExcel(payload: FreeTrialUsageReportFiltersDto): Promise<AxiosResponse<BlobPart>> {
    return Repository.post(`${resource}/ExportExcel`, payload, {
      withCredentials: true,
      responseType: "arraybuffer",
    });
  },
};
